<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
import {
  getQueryMonth,
} from '@qx/utils/index';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        checkStsOptions: [],
        form: [
          { // 业务年月
            label: '业务年月',
            value: 'settleMonth',
            type: 'date',
            default: getQueryMonth(),
            placeholder: '请选择业务年月',
            attr: {
              type: 'month',
            },
          },
          { // 员工姓名
            label: '员工姓名',
            value: 'userName',
            type: 'input',
            placeholder: '请输入员工姓名',
          },
          { // 员工手机
            label: '员工手机',
            value: 'userPhone',
            type: 'input',
            placeholder: '请输入员工手机',
          },
          { // 结算时间
            label: '结算时间',
            value: 'Time',
            type: 'date',
            placeholder: '请选择结算时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 工资状态
            label: '工资状态',
            value: 'checkSts',
            type: 'select',
            default: '-1',
            placeholder: '请选择工资状态',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 处理时间
      if (searchBoxData.Time && searchBoxData.Time.length > 0) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
      }
      if (searchBoxData.settleMonth && searchBoxData.settleMonth.indexOf('T') !== -1) {
        let date = new Date(searchBoxData.settleMonth);
        let nowMonth = date.getMonth();
        let year = date.getFullYear();
        if (Number(nowMonth) >= 0) {
          nowMonth = nowMonth + 1;
        }
        if (Number(nowMonth) >= 1 && Number(nowMonth) <= 9) {
          nowMonth = '0' + nowMonth;
        }

        searchBoxData.settleMonth = year + '-' + nowMonth;
      }
      const params = {
        driverSts: -1,
        complainSts: -1,
        subComplainSts: -1,
        salaryComplainSts: -1,
        salaryPattern: -1,
        carUserType: 3,
        ...searchBoxData,
      };
      delete params.Time;

      this.$refs.tableBox.saveSearchBoxData(params);
      this.$refs.tableBox.setImportExportParams(params);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SAL_SALARY_STATUS',
    });
    this.searchBoxData.checkStsOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
